import { Toast } from "primereact/toast";
import { createContext, useLayoutEffect, useMemo, useRef } from "react";

interface ToastContextValue {
  showToast: (toastObject: any) => void;
}

export const PrimeToastContext = createContext<ToastContextValue | null>(null);

const PrimeToastProvider = ({ children }: { children: React.ReactNode }) => {
  const toast = useRef<Toast>(null);

  const showToast = (toastObject: any) => {
    toast.current?.show(toastObject);
  };

  useLayoutEffect(() => {
    (window as any).PrimeToast = toast.current || {};
  }, []);

  const state = useMemo(
    () => ({
      showToast,
    }),
    []
  );

  return (
    <PrimeToastContext.Provider value={state}>
      <Toast ref={toast} className="app-toast" position="top-right" />
      {children}
    </PrimeToastContext.Provider>
  );
};

export default PrimeToastProvider;
